import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import Loading from "../components/Utils/Loading";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = UserAuth();
  const location = useLocation();

  if (loading)
    return (
      <div>
        <Loading />
      </div>
    );

  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
